import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_PERFORMANCE = createRequestTypes('ENTITIES_PERFORMANCE')

export const performance = {
  request: performanceId => action(ENTITIES_PERFORMANCE.REQUEST, { performanceId }),
  success: (performanceId, response) => action(ENTITIES_PERFORMANCE.SUCCESS, { performanceId, response }),
  failure: (performanceId, error) => action(ENTITIES_PERFORMANCE.FAILURE, { performanceId, error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/performance/performance-actions.js
 **/